import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=5c21a16c&scoped=true"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=5c21a16c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21a16c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c21a16c')) {
      api.createRecord('5c21a16c', component.options)
    } else {
      api.reload('5c21a16c', component.options)
    }
    module.hot.accept("./DashboardPage.vue?vue&type=template&id=5c21a16c&scoped=true", function () {
      api.rerender('5c21a16c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/plantNursery/dashboard/DashboardPage.vue"
export default component.exports